import { CUSTOM_DATASET_ID, ABC } from 'constants/constant';
import actionTypes from 'redux/actionTypes';

const initialState = {
	templateData: [],
	customAttribute: [],
	templateLoading: false,
	templateErrorCode: 0,
	selectedView: null,
	selectedTemplate: null,
	defaultFilter: undefined,
	defaultDlyFilter: undefined,
	defaultWklyFilter: undefined,
	defaultMultiWklyFilter: undefined,
	selectedPersona: undefined,
	sbuDepartments: [],
	subTempDetails: null,
	sbuDimDBTechName: [],
	cannedReportData: [],
	subTemplateLoading: false,
	customDatasetName: '',
	customDatasetDetails: {},
	savedCustomDatasets: []
};

const templateReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case actionTypes.GET_TEMPLATES:
		case actionTypes.GET_CANNED_REPORTS:
			return {
				...state,
				templateLoading: true,
				customDatasetName: ''
			};
		case actionTypes.GET_TEMPLATES_SUCCESS:
			return {
				...state,
				templateData: action.payload.map((item) => ({
					...item,
					customAttribute: state.customAttribute
				})),
				templateLoading: false,
				templateErrorCode: 0
			};
		case actionTypes.GET_TEMPLATES_FAILURE:
			return {
				...state,
				templateData: [],
				templateLoading: false,
				templateErrorCode: action.payload,
				selectedView: ''
			};
		case actionTypes.GET_CUSTOM_ATTRIBUTE:
		case actionTypes.GET_SBU_DEPARTMENTS:
			return {
				...state,
				templateLoading: true
			};
		case actionTypes.GET_CUSTOM_ATTRIBUTE_SUCCESS:
			return {
				...state,
				templateData: state.templateData?.map((item) => ({
					...item,
					customAttribute: action.payload
				})),
				customAttribute: action.payload,
				templateErrorCode: 0
			};
		case actionTypes.GET_CUSTOM_ATTRIBUTE_FAILURE:
			return {
				...state,
				customAttribute: [],
				templateErrorCode: action.payload
			};
		case actionTypes.SELECTED_TEMPLATE:
			return {
				...state,
				selectedTemplate: action.payload.templateId,
				selectedView: action.payload.view,
				defaultDlyFilter: action.payload.filter,
				defaultWklyFilter: action.payload?.filterWeekly,
				defaultMultiWklyFilter: action.payload?.filterWeeklyMultiWindow
			};
		case actionTypes.GET_SBU_DEPARTMENTS_SUCCESS:
			return {
				...state,
				sbuDimDBTechName: ['omni_dept_nbr'],
				sbuDepartments: action.payload,
				templateLoading: false
			};
		case actionTypes.GET_SBU_DEPARTMENTS_FAILURE:
			return {
				...state,
				sbuDepartments: [],
				templateLoading: false
			};
		case actionTypes.GET_SUB_TEMPLATE_DETAILS:
			return {
				...state,
				subTempDetails: null,
				subTemplateLoading: true
			};
		case actionTypes.GET_SUB_TEMPLATE_DETAILS_SUCCESS:
			return {
				...state,
				subTempDetails: action.payload,
				subTemplateLoading: false
			};
		case actionTypes.GET_SUB_TEMPLATE_DETAILS_FAILURE:
			return {
				...state,
				subTempDetails: null,
				templateErrorCode: action.payload,
				subTemplateLoading: false
			};
		case actionTypes.RESET_SUB_TEMPLATE_DETAILS:
			return {
				...state,
				subTempDetails: null
			};
		case actionTypes.GET_CANNED_REPORTS_SUCCESS:
			return {
				...state,
				templateLoading: false,
				templateErrorCode: 0,
				cannedReportData: action.payload
			};
		case actionTypes.GET_CANNED_REPORTS_FAILURE:
			return {
				...state,
				cannedReportData: [],
				templateLoading: false,
				templateErrorCode: action.payload
			};
		case actionTypes.GET_CUSTOM_DATASET_DETAILS_SUCCESS:
			return {
				...state,
				customDatasetError: 0,
				customDatasetDetails: action.payload
			};
		case actionTypes.GET_CUSTOM_DATASET_DETAILS_FAILURE:
			return {
				...state,
				customDatasetError: action.payload,
				customDatasetDetails: {}
			};
		case actionTypes.SAVE_CUSTOM_DATASET_SUCCESS:
			return {
				...state,
				customDatasetName: action.payload.datasetName,
				savedCustomDatasets: [...state.savedCustomDatasets, action.payload.data],
				isSaveSuccessForDataset: true,
				selectedTemplate: action.payload.data.customDatasetId,
				templateData: state.templateData?.filter((template) => {
					// if it is a custom dataset report with id -1, then delete it from the list of template data
					return !(template.view === ABC && template.templateId === CUSTOM_DATASET_ID);
				})
			};
		case actionTypes.RESET_SAVE_SUCCESS_FLAG:
			return {
				...state,
				isSaveSuccessForDataset: false
			};
		case actionTypes.SET_DATASET_EXISTS_FLAG:
			return {
				...state,
				isDatasetPresent: action.payload
			};
		case actionTypes.SET_CUSTOM_DATASET_NAME:
			return {
				...state,
				customDatasetName: action.payload.datasetName
			};
		case actionTypes.UPDATE_CUSTOM_DATASET_SUCCESS:
			return {
				...state,
				savedCustomDatasets: [
					...state.savedCustomDatasets.filter(
						(item) => item.customDatasetId !== action.payload.customDatasetId
					),
					action.payload
				],
				customDatasetName: action.payload.customDatasetName
			};
		case actionTypes.UPDATE_CUSTOM_DATASET_FAILURE:
		case actionTypes.SAVE_CUSTOM_DATASET_FAILURE:
			return {
				...state,
				customDatasetError: action.payload
			};
		case actionTypes.GET_SAVED_CUSTOM_DATASET_SUCCESS:
			return {
				...state,
				savedCustomDatasets: action.payload
			};
		case actionTypes.GET_SAVED_CUSTOM_DATASET_FAILURE:
		case actionTypes.DELETE_CUSTOM_DATASET_FAILURE:
			return {
				...state,
				savedCustomDatasetError: action.payload
			};
		case actionTypes.DELETE_CUSTOM_DATASET_SUCCESS:
			return {
				...state,
				savedCustomDatasets: [
					...state.savedCustomDatasets.filter((item) => item.customDatasetId !== action.payload)
				],
				isDeleteCustomDatasetSuccess: true
			};
		case actionTypes.RESET_DELETE_DATASET_SUCCESS_FLAG:
			return {
				...state,
				isDeleteCustomDatasetSuccess: false
			};
		default:
			return state;
	}
};

export default templateReducer;
